<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3202_10098)">
      <path
        d="M1.11111 0H18.8889C19.5026 0 20 0.497467 20 1.11111V18.8889C20 19.5026 19.5026 20 18.8889 20H1.11111C0.497467 20 0 19.5026 0 18.8889V1.11111C0 0.497467 0.497467 0 1.11111 0ZM8.89178 14.4444L16.7486 6.5877L15.1772 5.01636L8.89178 11.3018L5.74912 8.159L4.17777 9.73044L8.89178 14.4444Z"
        :fill="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_3202_10098">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsCheckSquare'
})

defineProps({
  fill: {
    type: String,
    default: '#361564'
  }
})
</script>
